// extracted by mini-css-extract-plugin
module.exports = {"container":"_a87b7fe"};